import React from 'react';
import {Route} from 'react-router-dom';
import loadable from '@loadable/component'
const LoginPage = loadable(() => import("./LoginPage.js"));


export default [
    <Route exact path="/login/" element={<LoginPage/>} />,
]